/**
 * Selectionne et mesure les composants d'une creation.
 * Ces fonctions partagent le meme ordre de calques que le lecteur
 * afin que les regles ciblent l'element attendu.
 */
import { TGDComponent, TGDSelector } from '../../../models/courses/graphicDesign';

/** Retire casse et marques pour rapprocher les textes saisis. */
export const normalizeText = (value: string | undefined): string =>
  typeof value === 'string'
    ? value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
      .replace(/\s+/g, ' ').trim() : '';

/** Retourne les composants correspondants, du calque haut vers le bas. */
export const selectComponents = (components: TGDComponent[], selector: TGDSelector): TGDComponent[] => {
  if (!Array.isArray(components) || !selector || selector.by === 'background') return [];
  const needle = selector.by === 'text' ? normalizeText(selector.value) : '';
  return components.filter(c => {
    if (!c) return false;
    switch (selector.by) {
      case 'id': return c.id === selector.value;
      case 'role': return c.role === selector.value;
      case 'type': return c.type === selector.value;
      case 'icon': return c.icon === selector.value;
      case 'text': return c.type === 'text' && needle !== '' && normalizeText(c.text).includes(needle);
      default: return false;
    }
  }).sort((a, b) => (b.layer ?? 0) - (a.layer ?? 0));
};

/** Mesure la taille visuelle pour les regles de hierarchie. */
export const sizeOf = (c: TGDComponent): number => c.type === 'text'
  ? c.fontSize ?? 16
  : Math.sqrt(Math.max(c.width, 0) * Math.max(c.height, 0));
